/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { EntityStatusEnum } from './entityStatusEnum';
import { RouteTypeEnum } from './routeTypeEnum';
import { ServerTypeEnum } from './serverTypeEnum';


export interface CreateSmsRouteDtoOfObject { 
    creatorId?: string;
    isOwnedByCoure: boolean;
    operatorCode?: string;
    entityStatusEnum: EntityStatusEnum;
    routeCanAllowMultipleBinds: boolean;
    publicName?: string;
    groupIdentifier?: string;
    accessType?: string;
    isTopLevel: boolean;
    smsRouteName?: string;
    description?: string;
    serverType: ServerTypeEnum;
    operatorId: number;
    rate: number;
    active: boolean;
    dateCreated: Date;
    smsRouteServer?: any;
    isContentRetrievalRoute: boolean;
    networkCode?: string;
    routeTypeName?: string;
    country?: string;
    countryCode?: string;
    mnc?: string;
    mcc?: string;
    contentBasedRouteName?: string;
    routeType: RouteTypeEnum;
    isLocal: boolean;
    defaultRoute: boolean;
}
